var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-container"},[_c('p',[_vm._v("版本所有 © "+_vm._s((new Date).getFullYear())+" 浙江水利水电勘测设计院")])])}
var staticRenderFns = []

export { render, staticRenderFns }